/* ============================================================
   Beni Product Tabs — <beni-product-tabs>
   Tabs + Swiper carousels + product cards + quick view + add to cart.
   Reuses window.loadMondoSwiper and mirrors product-form.js cart-add flow.
   ============================================================ */
(function () {
  if (customElements.get('beni-product-tabs')) return;

  var BP_TABLET = 750;
  var BP_DESKTOP = 990;

  function loadSwiper() {
    if (window.Swiper) return Promise.resolve();
    if (window.loadMondoSwiper) return window.loadMondoSwiper();
    return Promise.reject(new Error('Swiper loader unavailable'));
  }

  function toFloat(v, fallback) {
    var n = parseFloat(v);
    return isNaN(n) ? fallback : n;
  }

  function optValueName(v) {
    if (v == null) return '';
    if (typeof v === 'string') return v;
    return v.name || v.value || v.title || '';
  }

  function stripQuery(url) {
    return (url || '').split('?')[0];
  }

  /* Shopify standard money formatter */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }

    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;
    var value;
    switch (match[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'"); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  customElements.define('beni-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this._inited) return;
      this._inited = true;

      // config
      var cfgEl = this.querySelector('[data-ptabs-config]');
      try { this.config = JSON.parse(cfgEl.textContent); } catch (e) { this.config = {}; }
      this.strings = this.config.strings || {};
      this.moneyFormat = this.config.moneyFormat || '${{amount}}';

      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-ptabs-tab]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-ptabs-panel]'));

      // Quick view element — relocate to <body> to escape any clipping/stacking context.
      this.qv = this.querySelector('[data-ptabs-qv]');
      if (this.qv) {
        this._boundKeydown = this.onKeydown.bind(this);
        document.body.appendChild(this.qv);
        this.bindQuickViewChrome();
      }

      this.bindTabs();
      this.setupTabSlider();
      this.bindCards();

      // 「仅购物车有商品时显示」：订阅购物车变化，item_count>0 显示、=0 隐藏。
      if (this.dataset.requireCartItems === 'true') this.watchCartPresence();

      // Lazy-init carousels when scrolled near.
      var self = this;
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(function (entries) {
          if (entries[0] && entries[0].isIntersecting) {
            self._io.disconnect();
            self._io = null;
            self.bootActivePanel();
          }
        }, { rootMargin: '400px 0px' });
        this._io.observe(this);
      } else {
        this.bootActivePanel();
      }
    }

    /* -------------------- Cart presence (仅购物车有商品时显示) -------------------- */
    watchCartPresence() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      var self = this;

      function apply(count) {
        if (typeof count !== 'number') return;
        self.hidden = count === 0;
        // 隐藏期间轮播不会被 IntersectionObserver 初始化；从隐藏恢复显示时，
        // 若已初始化过则刷新尺寸（display:none 期间测量可能为 0）。
        if (!self.hidden) {
          self.panels.forEach(function (p) { if (p.__swiper) p.__swiper.update(); });
        }
      }

      this._cartPresenceUnsub = subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var count = event && event.cartData && event.cartData.item_count;
        if (typeof count === 'number') { apply(count); return; }
        // 兜底：payload 未带 item_count 时拉一次 cart.js。
        var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        fetch(cartUrl + '.js')
          .then(function (r) { return r.json(); })
          .then(function (c) { apply(c.item_count); })
          .catch(function () {});
      });
    }

    disconnectedCallback() {
      if (this._cartPresenceUnsub) { this._cartPresenceUnsub(); this._cartPresenceUnsub = null; }
      if (this._onTabResize) { window.removeEventListener('resize', this._onTabResize); this._onTabResize = null; }
      if (this._io) { this._io.disconnect(); this._io = null; }
      this.panels.forEach(function (p) { if (p.__swiper) { p.__swiper.destroy(true, true); p.__swiper = null; } });
      if (this._gallerySwiper) { this._gallerySwiper.destroy(true, true); this._gallerySwiper = null; }
      if (this.qv && this.qv.parentNode) this.qv.parentNode.removeChild(this.qv);
      document.removeEventListener('keydown', this._boundKeydown);
      document.documentElement.classList.remove('beni-ptabs-qv-open');
    }

    /* -------------------- Tabs -------------------- */
    bindTabs() {
      var self = this;
      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          self.activateTab(parseInt(tab.getAttribute('data-ptabs-tab'), 10));
        });
      });
    }

    /* Sliding active-tab indicator */
    setupTabSlider() {
      this.tabsEl = this.querySelector('.beni-ptabs__tabs');
      this.tabSlider = this.querySelector('[data-ptabs-tab-slider]');
      if (!this.tabsEl || !this.tabSlider || this.tabs.length === 0) return;

      var self = this;
      // 初次定位不带动画，避免加载时从 0 处滑入
      this.positionTabSlider(false);
      this.tabsEl.classList.add('has-slider');
      // 兜底：布局/字体就绪后再校正一次，防止首帧宽度测量为 0
      requestAnimationFrame(function () { self.positionTabSlider(false); });

      // 字体切换会改变 tab 宽度 → 重新定位
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { self.positionTabSlider(false); });
      }
      this._onTabResize = function () { self.positionTabSlider(false); };
      window.addEventListener('resize', this._onTabResize);
    }

    positionTabSlider(animate) {
      var slider = this.tabSlider;
      if (!slider || !this.tabsEl) return;
      var active = this.tabs.filter(function (t) { return t.classList.contains('is-active'); })[0] || this.tabs[0];
      if (!active) return;

      var barRect = this.tabsEl.getBoundingClientRect();
      var tabRect = active.getBoundingClientRect();
      var x = tabRect.left - barRect.left + this.tabsEl.scrollLeft;
      var y = tabRect.top - barRect.top + this.tabsEl.scrollTop;

      slider.classList.toggle('is-animate', !!animate);
      slider.style.width = tabRect.width + 'px';
      slider.style.height = tabRect.height + 'px';
      slider.style.transform = 'translate(' + x + 'px,' + y + 'px)';
    }

    activateTab(index) {
      var self = this;
      this.tabs.forEach(function (tab) {
        var active = parseInt(tab.getAttribute('data-ptabs-tab'), 10) === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.positionTabSlider(true);
      this.panels.forEach(function (panel) {
        var active = parseInt(panel.getAttribute('data-ptabs-panel'), 10) === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
        if (active) {
          self.initPanelSwiper(panel).then(function (sw) {
            if (sw) { sw.update(); if (self.config.autoplay && sw.autoplay) sw.autoplay.start(); }
          });
        } else if (panel.__swiper && panel.__swiper.autoplay) {
          panel.__swiper.autoplay.stop();
        }
      });
    }

    bootActivePanel() {
      var active = this.panels.filter(function (p) { return !p.hidden; })[0] || this.panels[0];
      if (active) this.initPanelSwiper(active);
    }

    initPanelSwiper(panel) {
      if (!panel) return Promise.resolve(null);
      if (panel.__swiper) return Promise.resolve(panel.__swiper);
      if (panel.__initing) return panel.__initing;

      var el = panel.querySelector('[data-ptabs-swiper]');
      if (!el) return Promise.resolve(null);

      var self = this;
      var cfg = this.config;
      panel.__initing = loadSwiper().then(function () {
        if (!window.Swiper || panel.__swiper) return panel.__swiper || null;

        var options = {
          slidesPerView: toFloat(cfg.colsMobile, 1.5),
          spaceBetween: parseInt(cfg.gapMobile, 10) || 12,
          speed: 300,
          // 动画进行中忽略新的滑动请求，避免快速连点箭头时打断 transform 过渡
          // （iOS Safari 对被打断的过渡重定基有闪跳/卡顿的已知问题）
          preventInteractionOnTransition: true,
          watchOverflow: true,
          // 标记可见 slide：配合 a11y.scrollOnFocus，避免"点开卡片弹窗→关闭还焦"时
          // Swiper 把已可见的 slide 当成不可见而 slideTo 到它，导致选中卡片闪跳到第一项。
          watchSlidesProgress: true,
          grabCursor: true,
          // scrollOnFocus:false → 还焦到 slide 内元素时不再自动 slideTo（新版本 Swiper 支持；
          // 旧版本忽略该键，由 watchSlidesProgress 兜底：可见 slide 不会被滚动）。
          a11y: { enabled: true, scrollOnFocus: false },
          breakpoints: {}
        };
        options.breakpoints[BP_TABLET] = {
          slidesPerView: toFloat(cfg.colsTablet, 2.5),
          spaceBetween: parseInt(cfg.gapDesktop, 10) || 12
        };
        options.breakpoints[BP_DESKTOP] = {
          slidesPerView: toFloat(cfg.colsDesktop, 4),
          spaceBetween: parseInt(cfg.gapDesktop, 10) || 12
        };

        if (cfg.loop) options.loop = true;
        if (cfg.autoplay) {
          options.autoplay = { delay: parseInt(cfg.autoplaySpeed, 10) || 5000, disableOnInteraction: false, pauseOnMouseEnter: true };
        }

        var prev = panel.querySelector('[data-ptabs-prev]');
        var next = panel.querySelector('[data-ptabs-next]');
        if (prev && next) {
          options.navigation = { prevEl: prev, nextEl: next, disabledClass: 'swiper-button-disabled' };
        }
        var progress = panel.querySelector('[data-ptabs-progress]');
        if (progress) {
          options.pagination = { el: progress, type: 'progressbar' };
        }

        panel.__swiper = new window.Swiper(el, options);

        // 当所有 slide 都能完整显示（无需滑动）时，隐藏进度条 + 左右按钮。
        var controls = panel.querySelector('.beni-ptabs__controls');
        if (controls) {
          var syncControls = function () {
            // 移除服务端预判类，改由运行时 isLocked 接管（同帧完成，二者一致则无位移）。
            controls.classList.remove('is-locked-d', 'is-locked-t', 'is-locked-m');
            controls.classList.toggle('is-hidden', !!panel.__swiper.isLocked);
            controls.classList.add('is-ready'); // 触发进度条淡入
          };
          panel.__swiper.on('lock', syncControls);
          panel.__swiper.on('unlock', syncControls);
          panel.__swiper.on('resize', syncControls);
          syncControls();
        }

        return panel.__swiper;
      }).catch(function (err) {
        console.warn('[beni-product-tabs] swiper init failed', err);
        return null;
      });

      return panel.__initing;
    }

    /* -------------------- Cards -------------------- */
    bindCards() {
      var self = this;
      var panels = this.querySelector('.beni-ptabs__panels');
      if (!panels) return;

      panels.addEventListener('click', function (evt) {
        var card = evt.target.closest('[data-ptabs-card]');
        if (!card || !panels.contains(card)) return;

        var atc = evt.target.closest('[data-ptabs-atc]');
        if (atc) {
          evt.preventDefault();
          if (atc.hasAttribute('disabled')) return;
          self.handleCardAtc(card, atc);
          return;
        }

        // click elsewhere on the card → quick view (if enabled)
        if (card.getAttribute('data-quick-view') === 'true') {
          evt.preventDefault();
          self.openQuickView(card, card);
          return;
        }

        // 主产品卡片：整卡点击直达 PDP。真链接（标题 / 拉伸覆盖层）交给其自身默认行为，
        // 只有点到非链接区域（图片/价格/描述）时由 JS 兜底跳转，确保整卡都可点。
        if (card.getAttribute('data-card-link') === 'true') {
          if (evt.target.closest('a')) return;
          var linkUrl = card.getAttribute('data-product-url');
          if (linkUrl) window.location = linkUrl;
        }
      });

      panels.addEventListener('keydown', function (evt) {
        if (evt.key !== 'Enter' && evt.key !== ' ' && evt.key !== 'Spacebar') return;
        var card = evt.target.closest('[data-ptabs-card]');
        if (!card || card !== evt.target) return; // only when the card itself is focused
        if (card.getAttribute('data-quick-view') !== 'true') return;
        evt.preventDefault();
        self.openQuickView(card, card);
      });
    }

    handleCardAtc(card, button) {
      var mode = card.getAttribute('data-atc-mode');
      if (mode === 'direct') {
        var variantId = card.getAttribute('data-variant-id');
        if (variantId) this.addToCart(variantId, 1, button, null);
        return;
      }
      // has variants → 打开方案② 弹窗选变体
      if (card.getAttribute('data-quick-view') === 'true') {
        this.openQuickView(card, button);
      } else {
        var url = card.getAttribute('data-product-url');
        if (url) window.location = url;
      }
    }

    getCardProduct(card) {
      if (card.__product) return card.__product;
      var script = card.querySelector('[data-ptabs-product]');
      if (!script) return null;
      try { card.__product = JSON.parse(script.textContent); } catch (e) { card.__product = null; }
      return card.__product;
    }

    /* -------------------- Add to cart (mirrors product-form.js) -------------------- */
    addToCart(variantId, quantity, button, onDone) {
      var self = this;
      var cart =
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer') ||
        document.querySelector('beni-cart-popover');

      if (button) button.classList.add('is-loading');

      var config;
      if (typeof fetchConfig === 'function') {
        config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
      } else {
        config = { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } };
      }

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity || 1);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

      fetch(addUrl, config)
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            self.notifyError(response.description || response.message);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, { source: 'beni-product-tabs', productVariantId: variantId, errors: response.errors || response.description, message: response.message });
            }
            return;
          }
          if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'beni-product-tabs', productVariantId: variantId, cartData: response });
          }

          // If added from the quick view, close it first (matches product-form quick-add behavior).
          if (onDone === 'closeQv' && self.qv && !self.qv.hidden) {
            self.closeQuickView();
          }
          if (typeof cart.renderContents === 'function') cart.renderContents(response);
          if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        })
        .catch(function (e) {
          console.error('[beni-product-tabs] add to cart failed', e);
          self.notifyError();
        })
        .finally(function () {
          if (button) button.classList.remove('is-loading');
        });
    }

    notifyError(message) {
      var msg = message || (window.cartStrings && window.cartStrings.error) || 'There was an error adding this item to your cart.';
      // Lightweight, non-blocking feedback.
      try { console.warn('[beni-product-tabs]', msg); } catch (e) {}
      window.alert(msg);
    }

    /* -------------------- Quick view -------------------- */
    bindQuickViewChrome() {
      var self = this;
      this.qv.querySelectorAll('[data-ptabs-qv-close]').forEach(function (el) {
        el.addEventListener('click', function () { self.closeQuickView(); });
      });
      var atc = this.qv.querySelector('[data-ptabs-qv-atc]');
      if (atc) {
        atc.addEventListener('click', function () {
          if (atc.hasAttribute('disabled')) return;
          if (self._currentVariant && self._currentVariant.available) {
            self.addToCart(self._currentVariant.id, 1, atc, 'closeQv');
          }
        });
      }
    }

    openQuickView(card, trigger) {
      // 方案②：交给全局弹窗 fetch /products/{handle}?view=quick-view 注入原生 product-info。
      var url = card.getAttribute('data-product-url');
      if (!url) return;
      this._lastTrigger = trigger || card;
      if (window.BeniQuickView && typeof window.BeniQuickView.open === 'function') {
        window.BeniQuickView.open(url, this._lastTrigger);
      } else {
        window.location = url;
      }
    }

    renderQuickView(product) {
      var qv = this.qv;
      var strings = this.strings;

      // Title + more info
      var titleEl = qv.querySelector('[data-ptabs-qv-title]');
      if (titleEl) titleEl.textContent = product.title || '';
      var moreInfo = qv.querySelector('[data-ptabs-qv-moreinfo]');
      if (moreInfo) moreInfo.setAttribute('href', product.url || '#');

      // Determine option state
      this._options = Array.isArray(product.options) ? product.options : [];
      this._variants = Array.isArray(product.variants) ? product.variants : [];
      var hasRealOptions = this._options.length > 0 &&
        !(this._options.length === 1 && this._variants.length === 1 && optValueName(this._options[0].values && this._options[0].values[0]) === 'Default Title');

      var firstAvail = this._variants.filter(function (v) { return v.available; })[0] || this._variants[0] || null;
      this._selected = firstAvail ? (firstAvail.options || []).slice() : [];
      this._currentVariant = firstAvail;

      this.buildVariants(hasRealOptions);
      this.buildSections(product);
      this.buildGallery(product);
      this.updateVariantState();
    }

    buildVariants(hasRealOptions) {
      var wrap = this.qv.querySelector('[data-ptabs-qv-variants]');
      if (!wrap) return;
      wrap.innerHTML = '';
      if (!hasRealOptions) return;

      var self = this;
      this._options.forEach(function (option, optIndex) {
        var group = document.createElement('div');
        group.className = 'beni-ptabs-qv__opt';

        var label = document.createElement('div');
        label.className = 'beni-ptabs-qv__opt-label';
        label.textContent = option.name || ('Option ' + (optIndex + 1));
        group.appendChild(label);

        var values = document.createElement('div');
        values.className = 'beni-ptabs-qv__opt-values';

        var seen = {};
        (option.values || []).forEach(function (raw) {
          var val = optValueName(raw);
          if (seen[val]) return;
          seen[val] = true;

          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'beni-ptabs-qv__pill';
          pill.textContent = val;
          pill.setAttribute('data-opt-index', optIndex);
          pill.setAttribute('data-opt-value', val);
          pill.setAttribute('aria-pressed', self._selected[optIndex] === val ? 'true' : 'false');
          pill.addEventListener('click', function () {
            self._selected[optIndex] = val;
            self.updateVariantState();
          });
          values.appendChild(pill);
        });

        group.appendChild(values);
        wrap.appendChild(group);
      });
    }

    /* find a variant matching the current selection */
    matchVariant() {
      var sel = this._selected;
      return this._variants.filter(function (v) {
        var opts = v.options || [];
        for (var i = 0; i < sel.length; i++) {
          if (opts[i] !== sel[i]) return false;
        }
        return true;
      })[0] || null;
    }

    updateVariantState() {
      var self = this;
      // reflect selection + availability on pills
      var pills = this.qv.querySelectorAll('[data-ptabs-qv-variants] .beni-ptabs-qv__pill');
      pills.forEach(function (pill) {
        var idx = parseInt(pill.getAttribute('data-opt-index'), 10);
        var val = pill.getAttribute('data-opt-value');
        pill.setAttribute('aria-pressed', self._selected[idx] === val ? 'true' : 'false');

        // available if some variant has this value at idx AND matches other selected options AND is available
        var available = self._variants.some(function (v) {
          var opts = v.options || [];
          if (opts[idx] !== val) return false;
          for (var i = 0; i < self._selected.length; i++) {
            if (i === idx) continue;
            if (self._selected[i] != null && opts[i] !== self._selected[i]) return false;
          }
          return v.available;
        });
        pill.classList.toggle('is-unavailable', !available);
      });

      var variant = this.matchVariant();
      this._currentVariant = variant;
      this.updatePrice(variant);
      this.updateAtc(variant);
      if (variant && variant.featured_image) this.syncGalleryToVariant(variant);
    }

    updatePrice(variant) {
      var qv = this.qv;
      var priceEl = qv.querySelector('[data-ptabs-qv-price]');
      var compareEl = qv.querySelector('[data-ptabs-qv-compare]');
      var saveEl = qv.querySelector('[data-ptabs-qv-save]');

      var price = variant ? variant.price : this._product.price;
      var compare = variant ? variant.compare_at_price : this._product.compare_at_price;

      if (priceEl) priceEl.innerHTML = formatMoney(price, this.moneyFormat);

      if (compare && compare > price) {
        if (compareEl) { compareEl.innerHTML = formatMoney(compare, this.moneyFormat); compareEl.hidden = false; }
        if (saveEl) {
          saveEl.textContent = (this.strings.save || 'Save') + ' ' + formatMoney(compare - price, this.moneyFormat).replace(/<[^>]*>/g, '');
          saveEl.hidden = false;
        }
      } else {
        if (compareEl) compareEl.hidden = true;
        if (saveEl) saveEl.hidden = true;
      }
    }

    updateAtc(variant) {
      var atc = this.qv.querySelector('[data-ptabs-qv-atc]');
      var text = this.qv.querySelector('[data-ptabs-qv-atc-text]');
      if (!atc || !text) return;
      if (!variant) {
        atc.setAttribute('disabled', 'disabled');
        text.textContent = this.strings.selectOptions || 'Unavailable';
      } else if (!variant.available) {
        atc.setAttribute('disabled', 'disabled');
        text.textContent = this.strings.soldOut || 'Sold out';
      } else {
        atc.removeAttribute('disabled');
        text.textContent = this.strings.addToCart || 'Add to cart';
      }
    }

    buildSections(product) {
      var wrap = this.qv.querySelector('[data-ptabs-qv-sections]');
      if (!wrap) return;
      wrap.innerHTML = '';
      var s = this.strings;

      // Overview (product description)
      if (product.description && product.description.trim()) {
        wrap.appendChild(this.sectionBlock(s.overview || 'Overview', product.description, 'html'));
      }
      // Key features (list or richtext metafield)
      if (product.key_features) {
        wrap.appendChild(this.sectionBlock(s.keyFeatures || 'Key Features', product.key_features, 'list'));
      }
      // In the box
      if (product.in_the_box) {
        wrap.appendChild(this.sectionBlock(s.inTheBox || 'In the box', product.in_the_box, 'auto'));
      }
      // Works with (chips)
      if (product.works_with) {
        wrap.appendChild(this.sectionBlock(s.worksWith || 'Works with', product.works_with, 'chips'));
      }
    }

    sectionBlock(title, value, mode) {
      var block = document.createElement('div');
      block.className = 'beni-ptabs-qv__sec';

      var h = document.createElement('div');
      h.className = 'beni-ptabs-qv__sec-title';
      h.textContent = title;
      block.appendChild(h);

      var list = Array.isArray(value) ? value : null;

      if (mode === 'chips' || (mode === 'auto' && list)) {
        var chips = document.createElement('div');
        chips.className = 'beni-ptabs-qv__chips';
        (list || String(value).split(/\r?\n|,/)).forEach(function (item) {
          var t = (typeof item === 'string' ? item : (item && (item.name || item.value) || '')).trim();
          if (!t) return;
          var chip = document.createElement('span');
          chip.className = 'beni-ptabs-qv__chip';
          chip.textContent = t;
          chips.appendChild(chip);
        });
        block.appendChild(chips);
      } else if (mode === 'list' || (list && mode !== 'html')) {
        var ul = document.createElement('ul');
        (list || String(value).split(/\r?\n/)).forEach(function (item) {
          var t = (typeof item === 'string' ? item : (item && (item.name || item.value) || '')).trim();
          if (!t) return;
          var li = document.createElement('li');
          li.textContent = t;
          ul.appendChild(li);
        });
        block.appendChild(ul);
      } else if (mode === 'html') {
        var div = document.createElement('div');
        div.className = 'beni-ptabs-qv__sec-text';
        div.innerHTML = value;
        block.appendChild(div);
      } else {
        var p = document.createElement('p');
        p.className = 'beni-ptabs-qv__sec-text';
        p.textContent = String(value);
        block.appendChild(p);
      }
      return block;
    }

    buildGallery(product) {
      var self = this;
      var wrapper = this.qv.querySelector('[data-ptabs-qv-gallery-wrapper]');
      var galleryEl = this.qv.querySelector('[data-ptabs-qv-gallery]');
      if (!wrapper || !galleryEl) return;

      if (this._gallerySwiper) { this._gallerySwiper.destroy(true, true); this._gallerySwiper = null; }
      wrapper.innerHTML = '';

      var images = Array.isArray(product.images) ? product.images.filter(Boolean) : [];
      if (images.length === 0 && product.variants && product.variants[0] && product.variants[0].featured_image) {
        images = [product.variants[0].featured_image];
      }

      images.forEach(function (src) {
        var slide = document.createElement('div');
        slide.className = 'swiper-slide';
        var img = document.createElement('img');
        img.className = 'beni-ptabs-qv__gallery-img';
        img.src = src;
        img.alt = product.title || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        slide.appendChild(img);
        wrapper.appendChild(slide);
      });

      var single = images.length <= 1;
      var prev = galleryEl.querySelector('[data-ptabs-qv-gallery-prev]');
      var next = galleryEl.querySelector('[data-ptabs-qv-gallery-next]');
      var dots = galleryEl.querySelector('[data-ptabs-qv-dots]');
      [prev, next].forEach(function (b) { if (b) b.classList.toggle('is-hidden', single); });
      if (dots) dots.style.display = single ? 'none' : '';

      this._galleryImages = images.map(stripQuery);
      this._gallerySingle = single;
      // Swiper is initialized in initGallery(), once the modal is visible (a
      // display:none container gives Swiper zero width).
    }

    initGallery() {
      var self = this;
      if (this._gallerySingle) return;
      var galleryEl = this.qv.querySelector('[data-ptabs-qv-gallery]');
      if (!galleryEl) return;
      var prev = galleryEl.querySelector('[data-ptabs-qv-gallery-prev]');
      var next = galleryEl.querySelector('[data-ptabs-qv-gallery-next]');
      var dots = galleryEl.querySelector('[data-ptabs-qv-dots]');

      loadSwiper().then(function () {
        if (!window.Swiper || self._gallerySwiper) return;
        self._gallerySwiper = new window.Swiper(galleryEl, {
          slidesPerView: 1,
          speed: 400,
          watchOverflow: true,
          navigation: prev && next ? { prevEl: prev, nextEl: next, disabledClass: 'swiper-button-disabled' } : false,
          pagination: dots ? { el: dots, clickable: true } : false
        });
        if (self._currentVariant && self._currentVariant.featured_image) self.syncGalleryToVariant(self._currentVariant);
      });
    }

    syncGalleryToVariant(variant) {
      if (!this._gallerySwiper || !this._galleryImages) return;
      var key = stripQuery(variant.featured_image);
      var idx = this._galleryImages.indexOf(key);
      if (idx >= 0 && idx !== this._gallerySwiper.activeIndex) {
        this._gallerySwiper.slideTo(idx);
      }
    }

    /* -------------------- Modal chrome -------------------- */
    showModal() {
      var self = this;
      var qv = this.qv;
      if (this._hideTimer) { clearTimeout(this._hideTimer); this._hideTimer = null; }
      document.removeEventListener('keydown', this._boundKeydown);
      qv.hidden = false;
      qv.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('beni-ptabs-qv-open');
      // reflow → transition in
      // eslint-disable-next-line no-unused-expressions
      qv.offsetHeight;

      // Container is now laid out — safe to init the gallery Swiper.
      this.initGallery();

      requestAnimationFrame(function () { qv.classList.add('is-open'); });

      var dialog = qv.querySelector('.beni-ptabs-qv__dialog');
      var closeBtn = qv.querySelector('[data-ptabs-qv-close]');
      if (typeof window.trapFocus === 'function') {
        window.trapFocus(dialog, closeBtn || dialog);
      } else if (dialog) {
        dialog.focus();
      }
      document.addEventListener('keydown', this._boundKeydown);

      // Safety: recalc once the open transition settles.
      setTimeout(function () { if (self._gallerySwiper) self._gallerySwiper.update(); }, 120);
    }

    closeQuickView() {
      var qv = this.qv;
      if (!qv || qv.hidden) return;
      qv.classList.remove('is-open');
      document.documentElement.classList.remove('beni-ptabs-qv-open');
      document.removeEventListener('keydown', this._boundKeydown);
      if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus(this._lastTrigger);
      else if (this._lastTrigger && this._lastTrigger.focus) this._lastTrigger.focus();

      setTimeout(function () {
        qv.hidden = true;
        qv.setAttribute('aria-hidden', 'true');
      }, 300);
    }

    onKeydown(evt) {
      if (evt.key === 'Escape' || evt.key === 'Esc') {
        evt.stopPropagation();
        this.closeQuickView();
      }
    }
  });
})();
